import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
import { toast } from '../hooks/use-toast';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch('https://formspree.io/f/mpwkagqz', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        toast({
          title: 'İletişim Formu Gönderildi',
          description: 'Mesajınızı aldık. En kısa sürede size geri dönüş yapacağız.',
        });
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: '',
        });
      } else {
        toast({
          title: 'Hata',
          description: 'Mesaj gönderilemedi. Lütfen tekrar deneyin.',
          variant: 'destructive',
        });
      }
    } catch (error) {
      toast({
        title: 'Hata',
        description: 'Bir hata oluştu. Lütfen tekrar deneyin.',
        variant: 'destructive',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div 
      className="min-h-screen relative"
      style={{
        backgroundImage: 'url(https://customer-assets.emergentagent.com/job_avukat-portal-6/artifacts/rf25a184_indir.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Navbar />

      {/* Hero Section with black semi-transparent blur background */}
      <section className="relative h-96 flex items-center justify-center pt-20">
        <div className="backdrop-blur-md bg-black/60 px-12 py-8 rounded-lg">
          <div className="text-center">
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 uppercase">
              İLETİŞİM
            </h1>
            <p className="text-xl text-gray-300">Bize ulaşın, size yardımcı olalım</p>
          </div>
        </div>
      </section>

      {/* Contact Section with black semi-transparent blur background */}
      <section className="relative py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="backdrop-blur-md bg-black/60 p-12 rounded-lg">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              {/* Contact Info */}
              <div className="space-y-8">
                <div className="bg-white/10 p-8 rounded-lg border border-white/20">
                <h2 className="text-xl md:text-3xl font-bold text-white mb-4 uppercase">
                  İLETİŞİM BİLGİLERİ
                </h2>
                <p className="text-gray-300 text-lg mb-6">
                  Hukuki danışmanlık ve dava takibi için bizimle iletişime geçebilirsiniz.
                </p>

                <div className="space-y-6">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
                      <MapPin className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h3 className="text-white font-semibold mb-1">Adres</h3>
                      <p className="text-gray-300">
                        Halkapınar, 1201/1. Sk. No:9 D:21<br />
                        35170 Konak/İzmir, Türkiye<br />
                        (Mert Ambalaj Üzeri)
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
                      <Phone className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h3 className="text-white font-semibold mb-1">Telefon</h3>
                      <a href="tel:05428220286" className="text-gray-300 hover:text-white transition-colors">
                        0 (542) 822 02 86
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
                      <Mail className="w-6 h-6 text-white" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-white font-semibold mb-1">E-posta</h3>
                      <a href="mailto:av.zeynepgur@outlook.com" className="text-gray-300 hover:text-white transition-colors block">
                        <span className="inline">av.zeynepgur</span>
                        <wbr />
                        <span className="inline">@outlook.com</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <Card className="bg-white/10 backdrop-blur-md border-white/20">
                <CardContent className="p-6">
                  <h3 className="text-white font-semibold text-lg mb-2">Çalışma Saatleri</h3>
                  <div className="space-y-1 text-gray-300">
                    <p>Pazartesi - Cuma: 09:00 - 18:00</p>
                    <p>Cumartesi: Kapalı</p>
                    <p>Pazar: Kapalı</p>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Contact Form */}
            <Card className="bg-white/10 backdrop-blur-md border-white/20 mt-8">
              <CardContent className="p-8">
                <h2 className="text-xl md:text-2xl font-bold text-white mb-6 uppercase">
                  BİZE ULAŞIN
                </h2>
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <Label htmlFor="name" className="text-white mb-2 block">
                      Ad Soyad *
                    </Label>
                    <Input
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="bg-white/10 border-white/20 text-white placeholder:text-gray-400 focus:border-white"
                      placeholder="Adınız ve soyadınız"
                    />
                  </div>

                  <div>
                    <Label htmlFor="email" className="text-white mb-2 block">
                      E-posta *
                    </Label>
                    <Input
                      id="email"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="bg-white/10 border-white/20 text-white placeholder:text-gray-400 focus:border-white"
                      placeholder="email@example.com"
                    />
                  </div>

                  <div>
                    <Label htmlFor="phone" className="text-white mb-2 block">
                      Telefon
                    </Label>
                    <Input
                      id="phone"
                      name="phone"
                      type="tel"
                      value={formData.phone}
                      onChange={handleChange}
                      className="bg-white/10 border-white/20 text-white placeholder:text-gray-400 focus:border-white"
                      placeholder="+90 XXX XXX XX XX"
                    />
                  </div>

                  <div>
                    <Label htmlFor="subject" className="text-white mb-2 block">
                      Konu *
                    </Label>
                    <Input
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      className="bg-white/10 border-white/20 text-white placeholder:text-gray-400 focus:border-white"
                      placeholder="Mesaj konusu"
                    />
                  </div>

                  <div>
                    <Label htmlFor="message" className="text-white mb-2 block">
                      Mesaj *
                    </Label>
                    <Textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows={6}
                      className="bg-white/10 border-white/20 text-white placeholder:text-gray-400 focus:border-white resize-none"
                      placeholder="Mesajınızı buraya yazın"
                    />
                  </div>

                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-[#997938] hover:bg-[#8a6a2f] text-white font-semibold py-6 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <Send className="w-5 h-5 mr-2" />
                    {isSubmitting ? 'Gönderiliyor...' : 'Mesaj Gönder'}
                  </Button>
                </form>
              </CardContent>
            </Card>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;